import { AppProvider } from '../providers';
import { Routing } from '../routing/routing.component';

export const App = (): JSX.Element => (
  <AppProvider>
    <Routing />
  </AppProvider>
);
